
    import I18n from 'i18nObj';
    
      import 'translations/editor.keyboard_shortcuts';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('editor.keyboard_shortcuts');
  